import {ReportModel} from "@fedeltapointofsale/data-client";
import {ProductCostingBomReportData} from "./product-costing-bom-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ProductCostingBomReportModel extends ReportModel<ProductCostingBomReportData> {
    constructor(injector: Injector) {
        super(injector, ProductCostingBomReportData);
    }
}
